import stringDelimiter from './stringDelimiter'
import i18n from 'i18n'
let langStr
const userLang = window.location.pathname.substr(1, 2)
if (userLang === 'ar' && localStorage.getItem('i18nextLng') !== 'ar') {
  langStr = 'ar'
  localStorage.setItem('i18nextLng', 'ar')
  i18n.changeLanguage('ar')
  document.getElementsByTagName('html')[0].style.direction = 'rtl'
} else if (userLang === 'en' && localStorage.getItem('i18nextLng') !== 'en') {
  langStr = 'en'
  localStorage.setItem('i18nextLng', 'en')
  i18n.changeLanguage('en')
  document.getElementsByTagName('html')[0].style.direction = 'ltr'
} else {
  const lang = stringDelimiter(localStorage.getItem('i18nextLng'))
  langStr = lang ? lang : JSON.parse(lang)
  // const langUrl = langStr ? langStr : JSON.parse(langStr)
}

export default langStr
